import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { USER_MODULE_NAMESPACE } from '../../../store/user/user-types.store'
import { IProfileNotification } from '../../../models/profile-notification'
import { PROFILE_NOTIFICATION_MODULE_NAMESPACE, PROFILE_NOTIFICATION, PROFILE_SET_NOTIFICATION_ROWS, PROFILE_PATCH_NOTIFICATION, PROFILE_NOTIFICATION_LOADERS } from '../../../store/profile-notification/profile-notification-types.store'
const UserStore = namespace(USER_MODULE_NAMESPACE)
const ProfileNotificationStore = namespace(PROFILE_NOTIFICATION_MODULE_NAMESPACE)

@Component({
  components: {
    'notification-data-table': async () => import('../components/profile-notification-data-table/ProfileNotificationDataTable.vue'),
    'notification-title-loader': async () => import('../loaders/profile-notif-title-loader/ProfileNotifTitleLoader.vue')
  }
})
class ProfileChildNotification extends Vue {
  @Prop({ default: false, type: [ Boolean ] })
  visible: boolean;
  @Prop({ default: false, type: [ Boolean ] })
  loading: boolean;

  @UserStore.Getter
  userInfo: any;
  @ProfileNotificationStore.Getter loaders: Map<string,boolean>

  @ProfileNotificationStore.Getter
  profileNotifications: { section_notification_name: string, section_notification_option: IProfileNotification[] }[] ;

  @ProfileNotificationStore.Action(PROFILE_NOTIFICATION)
  storeProfileNotifications: () => Promise<any>;

  @ProfileNotificationStore.Action(PROFILE_PATCH_NOTIFICATION)
  storePatchProfileNotifications: (IProfileNotification) => Promise<any>;

  @ProfileNotificationStore.Mutation(PROFILE_SET_NOTIFICATION_ROWS)
  storeSetRowsProfileNotification;

  pagination: any;
  dataTableProps: any;

  readonly LOADING_SECTIONS: { section_notification_name: string, section_notification_option: IProfileNotification[] }[] = [
    { section_notification_name: "loading section 1", section_notification_option:  [1,2,3,4,5].map(item=> ({ name: `loading option ${item}` }) as IProfileNotification  ) },
    { section_notification_name: "loading section 2", section_notification_option:  [1,2,3,4,5].map(item=> ({ name: `loading option ${item}` }) as IProfileNotification ) }
  ]

  constructor () {
    super()
  }

  created () {
    this.storeProfileNotifications()
  }

  get lblSetting () {
    return {
      ...require('../../../locales/profile').default,
      ...require('../../../locales/generic-labels').default
    }
  }

  get profileNotificationsLocalStorage () : { section_notification_name: string, section_notification_option: IProfileNotification[] }[] {
    return JSON.parse(localStorage.getItem('profile-notification'))
  }

  get coModalVisible (): boolean {
    return this.visible
  }
  set coModalVisible (value: boolean) {
    this.$emit('update:visible', value)
  }

  get notifications (): { section_notification_name: string, section_notification_option: IProfileNotification[] }[] {
    return !this.coLoader ? this.profileNotifications : this.LOADING_SECTIONS
  }

  set notifications (rows: { section_notification_name: string, section_notification_option: IProfileNotification[] }[]) {
    this.storeSetRowsProfileNotification(rows)
  }

  get coLoader(): boolean{
    return this.loaders.get(PROFILE_NOTIFICATION_LOADERS.NOTIFICATIONS_DETAILS)
  }

  onClickCheckbox (props, type) {
    let item = {
      ...this.notifications
          .reduce((accum,current)=> { return [...accum,...current.section_notification_option] },[])
          .find(notification => notification.setting_id === props.item.setting_id)
      }

    item[ type ] = !item[ type ]
    this.notifications = [ item ]
    let previousNotification = this.profileNotificationsLocalStorage
                                                .reduce((accum,current)=> [...accum,...current.section_notification_option] ,[])
                                                .find(notification => notification.setting_id === props.item.setting_id)
    if (item.app !== previousNotification.app ||
      item.sms !== previousNotification.sms ||
      item.email !== previousNotification.email) {
      props.selected = true
    } else {
      props.selected = false
    }
    this.storePatchProfileNotifications(item)
      .then(response => {
        this.$emit('display-snackbar', this.$t(this.lblSetting.preferenceUpdated), 'primaryDark')
      })
      .catch(error => {
        this.$emit('display-snackbar', this.$t(this.lblSetting.lblErrorHappen), 'error')
      })
  }

  notificationAnchorId(title: string){
    return `notification-parameter-${title}`
  }
}

export default ProfileChildNotification



// WEBPACK FOOTER //
// ./src/containers/profile/profile-child-notification/index.ts